export default __webpack_public_path__ + "locales/vi/SharingPanel.json?hash=f33cfacdb2364bbadacfcbd199c4f723";